import type { RecommendedCoursePlanItem } from "@brookbush/types";

import useSWR from "swr";

import { toArray } from "~/lib/toArray";

const useRecommendedCoursePlan = (certificationSlug?: string) => {
	const {
		data: recommendedCoursePlan,
		isLoading,
		...rest
	} = useSWR<RecommendedCoursePlanItem[]>(
		certificationSlug &&
			`/certifications/${certificationSlug}/recommended-course-plan`,
	);

	const coursePlan = toArray<RecommendedCoursePlanItem>(recommendedCoursePlan);

	const isPlanItemPassed = (planItemKey: string) => {
		return coursePlan.find(
			(item) =>
				item._key === planItemKey &&
				(item.isPassed ?? (item.earnedCoreCredits || 0) >= item.credits),
		);
	};

	return {
		recommendedCoursePlan: coursePlan,
		isLoadingRecommendedCoursePlan: isLoading,
		isPlanItemPassed,
		...rest,
	};
};

export default useRecommendedCoursePlan;
